'use client';

import { c as _c } from "react/compiler-runtime";
import { NebulyPageStatusPanel } from '@/domains/pages/components/nebuly-page-status-panel';
import type { PropsWithChildren, ReactNode } from 'react';
type NebulyPageEmptyStateProps = {
  title: string;
  description?: string;
  icon?: ReactNode;
  action?: ReactNode;
  className?: string;
  'data-testid'?: string;
};
export function NebulyPageEmptyState(t0) {
  const $ = _c(8);
  const {
    title,
    description,
    icon,
    action,
    className,
    children,
    "data-testid": dataTestId
  } = t0;
  let t1;
  if ($[0] !== action || $[1] !== children || $[2] !== className || $[3] !== dataTestId || $[4] !== description || $[5] !== icon || $[6] !== title) {
    t1 = <NebulyPageStatusPanel className={className} data-testid={dataTestId} icon={icon} title={title} description={description} actions={action}>{children}</NebulyPageStatusPanel>;
    $[0] = action;
    $[1] = children;
    $[2] = className;
    $[3] = dataTestId;
    $[4] = description;
    $[5] = icon;
    $[6] = title;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
}